export default "__VITE_ASSET__DNz1QbIO__"